/** @jsx jsx */
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import HighlightText from '@atlassian/jira-software-highlight-text/src/ui/index.tsx';

type Props = {
	highlight?: string[];
	text: string;
};

export const CardKey = ({ highlight, text }: Props) => {
	return (
		<div css={styles.root}>
			<div css={styles.key}>
				<HighlightText highlight={highlight ?? null} text={text} />
			</div>
		</div>
	);
};

const styles = cssMap({
	root: {
		display: 'flex',
		flex: 1,
		minWidth: '0px',
		whiteSpace: 'nowrap',
	},
	key: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		font: token('font.body.UNSAFE_small'),
		fontWeight: token('font.weight.semibold'),
		color: token('color.text.subtle'),
	},
});
